import { PopUpStore } from "../../Common/_stores/PopUpStore";
import { BudgetsPopUps } from "../BudgetsPopUps";

export const BudgetsPopUpStore = {
    ...PopUpStore,
    actionShowRemoveBudgetPopUp: uid => PopUpStore.actionShow(
        BudgetsPopUps.IDS.DELETE_BUDGET,
        { uid },
    ),
};